import React from 'react';
import { Box, Button, Card, Paragraph } from 'bumbag';
import _get from 'lodash/get';

import { LandingPage } from '@medipass/react-core';
import { Link as RouterLink, withRouter } from '@medipass/react-core/router';
import sdk from '@medipass/web-sdk';

import HealthFundAccountForm from 'legacy/components/account/health-fund-accounts/HealthFundAccountForm';
import WithAuthentication from 'legacy/components/WithAuthentication';
import { updateMembersHealthFundAccount } from 'legacy/utils/health-fund-accounts';
type Props = {
  history: Record<string, any>;
};

class CreateHealthFundAccount extends React.PureComponent<Props> {
  handleAddHealthFundAccount = async (healthFundAccount: Record<string, any>) => {
    const { history } = this.props;

    const memberId = _get(sdk, 'member._id');

    const body = await updateMembersHealthFundAccount({
      healthFundAccount,
      memberId,
    });
    // TODO: Enable soon
    // history.push('/account/onboarding/create-medicare-account');
    history.push('/');
    return body;
  };
  render = () => (
    <WithAuthentication>
      <LandingPage
        description={
          <Paragraph>
            Add your health fund details to enable us to instantly process any benefits owing to you.
          </Paragraph>
        }
        title="Add health fund card"
      >
        <Card>
          <HealthFundAccountForm
            title="Add your health fund card"
            isMobileTitle={false}
            isSubmitButtonInsideSection
            onSubmit={this.handleAddHealthFundAccount}
            submitButtonRenderer={({ isLoading }) => (
              <Box textAlign="center">
                <Button palette="secondary" isLoading={isLoading} size="medium" width="100%" type="submit">
                  CONTINUE
                </Button>
                {/*TODO: enable soon - <Link to="/account/onboarding/create-medicare-account">*/}
                {/* @ts-expect-error TS(2322): Type '{ children: string[]; use: any; to: string; ... Remove this comment to see the full error message */}
                <Button use={RouterLink} to="/" palette="primary" marginTop="major-1" variant="ghost">
                  I{"'"}ll do this later
                </Button>
              </Box>
            )}
          />
        </Card>
      </LandingPage>
    </WithAuthentication>
  );
}

export default withRouter(CreateHealthFundAccount);
